class OffsetScroll extends HTMLElement {
  constructor() {
    super();

    const containerSelector = this.dataset.containerSelector;
    if (!containerSelector) throw new Error('offset-scroll-element missing data-container-selector');

    const offset = this.dataset.offset;
    if (!offset) throw new Error('offset-scroll-element missing data-offset');

    const isVertical = this.dataset.isVertical === 'true';

    this.containerSelector = containerSelector;
    const container = document.querySelector(containerSelector);

    this.addEventListener('click', () => {
      if (isVertical) {
        container.scrollTo({
          top: container.scrollTop + offset * container.clientHeight,
          behavior: 'smooth',
        });
      } else {
        container.scrollTo({
          left: container.scrollLeft + offset * container.clientWidth,
          behavior: 'smooth',
        });
      }
    });
  }
}

customElements.define('offset-scroll-element', OffsetScroll);
